export enum Country {
    Switzerland,
    Germany,
    Italy,
    France,
    Austria,
    Netherlands,
}

export enum DataOrigin {
    Pos,
    Portal,
}

export enum TableShape {
    Rectangle,
    Round,
}

export enum RoomShape {
    Landscape,
    Square,
    Portrait,
}

export enum ServiceType {
    Covid,
    Documents,
    Order,
    Ticketing,
    Website,
    Offer,
    Pay,
    RoomPlan,
}

export enum Currency {
    Chf,
}

export enum RatingValue {
    VeryBad,
    Bad,
    Ok,
    Good,
    VeryGood,
}

export enum OrderState {
    Open,
    FullyPaid,
    Closed,
    Canceled,
    TimedOut,
    NotPaid,
    ClosedNotPaid,
}

export enum FulfillmentPositionDisplayMode {
    None,
    Duration,
    Position,
}

export enum FulfillmentHandling {
    None,
    OnlyOperator,
    OperatorAndApp,
}

export enum OneFulfillmentPerOrderMode {
    NotForced,
    Forced,
    LetCustomerDecide,
}

export enum FulfillmentState {
    Created,
    InPreparation,
    Ready,
    Fulfilled,
}

export enum SchedulingMode {
    None,
    PickupTime,
    DeliveryTime,
    Time,
}

export enum BuyerRequirement {
    None,
    Email,
    SignedUp,
    EmailConfirmed,
}

export enum ConsumptionSite {
    OnSite,
    OffSite,
}

export enum ConsumptionSiteDisplayMode {
    None,
    PickUpAddress,
    LocationAddress,
    DeliveryAddress,
}

export enum CovidVerificationMode {
    None,
    TwoG,
    ThreeG,
    TwoGPlus,
}

export enum PaymentState {
    Intented,
    Confirmed,
    Declined,
}

export enum BillType {
    TableBill,
    OrderBill,
}

export enum BillListType {
    OrdersForNowOnly,
    OrdersForNowOrLaterOnly,
}

export enum PaymentProvider {
    Stripe,
    Wallee,
    PayTec,
    Worldline,
    PostFinance,
}

export enum WorldlineTerminalPaymentStatus {
    Approved,
    Declined,
    Unconfirmed,
}

export enum PaymentClient {
    Browser,
    PaymentDevice,
}
export enum Language {
    German,
    English,
    French,
    Italian,
}

export enum DeviceFamily {
    Ios,
    Android,
    Pc,
    Other,
}

export enum TaskExecutionState {
    Inactive,
    Scheduled,
    Executing,
}

export enum TaskSuccessState {
    Success,
    Failed,
}

export enum IssueState {
    Open,
    InProgress,
    Closed,
}

export enum SaleInquiryState {
    FirstContact,
    AutoEnroled,
    InProgress,
    Closed,
}

export enum DeallocationReason {
    OrderClosed,
    Guest,
    Signout,
    NewAllocation,
    AutoDeallocate,
    IdentityDelete,
    TableReset,
}

export enum Weekday {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 4,
    Thursday = 8,
    Friday = 16,
    Saturday = 32,
    Sunday = 64,
}

export enum PricingModel {
    Free,
    Standard,
    Professional,
}

export enum LocationState {
    Active,
    Suspended,
    Deleted,
}

export enum PrintJobState {
    Pending,
    Printed,
    Failed,
    Unconfirmed,
}

export enum PrinterProtocolType {
    EscPos,
}

export enum PrinterState {
    Offline,
    OutOfPaper,
    OpenTrail,
    ErrorState,
    Ready,
}

export enum PrintLayout {
    OrderAndPay80Mm,
    OrderAndPay80MmBig,
    OrderAndPay76Mm,
}

export enum PrintFontSize {
    Small,
    Medium,
    Large,
}

export enum SalesReportViewType {
    Category,
    Article,
    Detail,
}

export enum OfferScheduleType {
    Standard,
    DifferentOffer,
    Closed,
}

export enum CancellationState {
    PartiallyCancelled,
    Cancelled,
}

export enum CancellationMode {
    WholeOrder,
    Positions,
    Amount,
}

export enum CancellationPositionType {
    OrderItem,
    Tip,
}

export enum RefundMode {
    Online,
    Offline,
}

export enum ProductionTileViewMode {
    Detailed,
    Overview,
}

export enum NewOrdersViewMode {
    AtTheTop,
    AtTheBottom,
}

export enum FulfilmentTileSize {
    Normal,
    Large,
}

export enum CartControllerMode {
    Order,
    Offer,
}

export enum OrderStateMode {
    All,
    NotFulfilled,
    Ready,
    NotPaid,
}

export enum OperatorPlaySoundMode {
    FulfillmentInPreparation,
    FulfillmentReady,
    FulfillmentFulfilledNotPaid,
}

export enum ItemAvailability {
    Available,
    NotAvailable,
}

export enum ItemType {
    MainItems,
    Options,
}

export enum ArticleUnavailabilityReason {
    Manual,
    TemporaryUnavailable,
    MaxFulfillmentNumberReached,
}

export enum PaymentFor {
    Order,
    Bill,
}

export enum PaymentMethodMode {
    Online,
    Offline,
}

export enum ReceiptType {
    Order,
    Payment,
}

export enum FulfillmentProductionState {
    InPreparation,
    ReadyShortly,
    Ready,
    FulfilledNotPaid,
}

export enum JoinPrintingItemsMode {
    PerOrder,
    PerItem,
    PerOrderAndPerItem,
}

export enum ServiceAvailableFor {
    EndUsers,
    Operators,
}

export enum UserItemSelectionChangeReason {
    UserAction,
    SelectionsReset,
    SelectionsTransfer,
    SelectionsRemove,
}

export enum OrderCartType {
    OrderNow,
    Preorder,
}

export enum LogLevel {
    Trace,
    Debug,
    Information,
    Warning,
    Error,
    Critical,
    None,
}

export enum VisibleEndUserProperties {
    None = 0,
    FirstNameShortLastName = 1,
    Email = 2,
    PhoneNumber = 4,
    FirstNameLastName = 8,
}

export enum PrintWhenOrderHasStatus {
    None = 0,
    Confirmed = 1, // default
    Ready =2 ,
}

export enum CancellationReason {
    IncorrectIncompleteItemInformation,
    OrderedIncorrectlyEndUser,
    OrderedIncorrectlyStaffMember,
    EndUserChangedMind,
    ItemNotAvailable,
    PriceWrong,
    BusinessClosedAtFulfilmentTime,
    LossBreakageStaffMember,
    LateFulfilment,
    BadQualityPresentation,
    LossBreakageEndUser,
    CustomerDidNotPayWalkout,
    Other,
}

export enum VoucherType {
    Value,
    Specific,
}

export enum VoucherState {
    Enabled,
    Redeemed,
    Cancelled,
    Expired,
}

export enum DashboardStatsPeriod {
    Today,
    Date,
    Yesterday,
    Past7Days,
    Past8Days,
    Past4Weeks,
    Past5Weeks,
    Past3Months,
    Past12Months,
    Past13Months,
    CurrentWeek,
    LastWeek,
    CurrentMonth,
    LastMonth,
    CurrentYear,
    LastYear,
    TwoYearsAgo,
    ThreeYearsAgo,
    FourYearsAgo
}

export enum DashboardStatsGranularity {
    Hours,
    Days,
    Weeks,
    Months,
}

export enum DiscountType {
    Percentage,
    Absolute,
}

export enum DiscountAccessMode {
    Code = 1,
    Button = 2,
    CodeOrButton = 3,
    Automatically = 4,
}

export enum DiscountStatus {
    Enabled = 0,
    NotYetValid = 1,
    Cancelled = 2,
    Expired = 3,
}

export enum OperatorReportClaimValue {
    DontHaveAccessInOperatorAndMobilePos = 0,
    ViewOnlyOwnSalesAndRevenue = 1,
    ViewAllSalesAndRevenue = 2,
}

export enum OperatorCancellationClaimValue {
    None = 0,
    MakeCancellationsAndRefunds = 1,
}

export enum OperatorTransferClaimValue {
    CannotTransfer = 0,
    CanTransferOwn = 1,
    CanTransferAll = 2,
}

export enum OperatorItemAvailabilityAndStockLevelClaimValue {
    CannotEdit = 0,
    CanEdit = 1,
}

export enum OrdererNameRequirement {
    NotRequired,
    Required,
    Optional,
}

export enum OrdererPhoneNumberRequirement {
    NotRequired,
    Required,
    Optional,
    ConfirmedBlockOrder,
}

export enum OrdererEmailRequirement {
    NotRequired,
    Required,
    Optional,
    ConfirmedBlockOrder,
    ConfirmedCancelOrder,
}

export enum OrdererRegisteredRequirement {
    NotRequired,
    Required,
}

export enum PredefinedResourceCode {
    Seats,
}

export enum RefundabilityType {
    Refundable,
    NoRefundable,
    RefundableWithFee,
    RefundOptionalForOperators,
}

// Reservation

export enum ReservationAcceptanceState {
    Open,
    PendingOperator,
    PendingEndUser,
    Accepted,
    Declined,
}

export enum ReservationAssignmentState {
    Unassigned,
    Tentative,
    Assigned,
    Fixed,
}

export enum ReservationAttendanceState {
    NotArrived,
    PartiallyArrived,
    Arrived,
    PartiallySeated,
    Seated,
    NoShow,
    Completed,
}
export enum OrderBillCustomNameSource {
    OrderNumber,
    PartyName,
}

export enum OperatorsMustAcceptOrDeclineReservation {
    Never,
    OverbookingAbove,
    IfNoTableCanBeAssigned,
    Always,
}

export enum OperatorsCanBreakReservationRules {
    DoNotAllow,
    AllowAndNotify,
}

export enum UiPaymentState {
    Preparing,
    MethodSelection,
    ReadyToPay,
    Paying,
    Confirmed,
    Failed,
    Ordering, //For pay later orders
}

export enum PostFinanceContract {
    BrowserAndDevicePayment,
    PaymentDeviceOnly
}

export enum OfferCategoryHighlightType {
    Normal,
    FullWidth
}

export enum AttributeEffect {
    Include,
    Exclude
}

export enum AttributeDisplayType {
    None = 0,
    Icon = 1,
    Flag = 2,
    Filter = 4,
}

export enum AttributeFlagDisplayTo {
    EndUsersAndOperators,
    EndUsers,
    Operators,
}

// mirrors Tastier.Dto.Enums.PermalinkMode - the values travel over the wire as numbers
// and the order is also the order of the dropdown, so it has to stay in sync
export enum PermalinkMode {
    None,
    Kiosk,
    Normal
}